import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import '../../../../../src/App.css'
import { submitOtherProductMaster } from "../../../../services/apiService";
import { LuSave } from "react-icons/lu";
import { GiCrossedBones } from "react-icons/gi";
import InsurerDropdown from "../../../../utils/Insurer";

const AddOtherProduct = () => {
  const [isRenewableEnabled, setIsRenewableEnabled] = useState(false);
  const [isMemberEnabled, setIsMemberEnabled] = useState(false);
  const [selectedYears, setSelectedYears] = useState(1);

  const validationSchema = Yup.object({
    insurer: Yup.string().required("Insurer is required"),
    productName: Yup.string().required("Product Name is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const formattedData = {
        TObject: {
          Oth_Product_ID: 0,
          Oth_Product_Name: values.productName,
          Oth_Product_ShortName: values.productShortName,
          NoofYears: `${selectedYears} yrs`,
          Is_Renewable: isRenewableEnabled,
          Is_Members: isMemberEnabled,
          CreatedBy: 1,
        }
      };
      await submitOtherProductMaster(formattedData);
      alert("Form submitted successfully!");
      resetForm();
      setIsRenewableEnabled(false);
      setIsMemberEnabled(false);
      setSelectedYears(1);
    } catch (error) {
      console.error("Form submission failed:", error);
    }
  };

  return (
    <div className="formContainer lg:p-4 md:p-4 sm:p-1">
      <div
        className="flex flex-col lg:mx-5 p-4 border rounded bg-white"
        style={{ boxShadow: "0px 0px 12px gray" }}
      >        <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">Other Product Master</h5>

        <Formik
          initialValues={{
            insurer: "",
            productName: "",
            productShortName: "",
            periodAvailable: "",
            isNoClaimDiscount: false,
            isCummulativeBonus: false,
            isFamilyDiscount: false,
            isCoPayDiscount: false,
            isTopUp: false,
            isDailCash: false,
            webURL: "",
            minEntryAge: 18,
            maxEntryAge: 35
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form id="otherProductForm">
              <div className="row">
                <div className="col-md-6 mb-3">
                <InsurerDropdown name="insurer" insurerType={'G'} />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Product Name <span className="text-danger">*</span>
                  </label>
                  <Field type="text" name="productName" className="form-control custom-shadow w-full px-3 py-2" />
                  <ErrorMessage name="productName" component="div" className="text-danger" />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Product Short Name</label>
                  <Field type="text" name="productShortName" className="form-control custom-shadow w-full px-3 py-2" />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">No of years</label>
                  <div className="d-flex gap-2">
                    {[1, 2, 3].map((year) => (
                      <button
                        key={year}
                        type="button"
                        className={`toggle-btn ${selectedYears === year ? "active" : ""}`}
                        onClick={() => setSelectedYears(year)}
                      >
                        {year}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Is Renewable?</label>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className={`toggle-btn ${isRenewableEnabled ? "active" : ""}`}
                      onClick={() => setIsRenewableEnabled(true)}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      className={`toggle-btn ${!isRenewableEnabled ? "active" : ""}`}
                      onClick={() => setIsRenewableEnabled(false)}
                    >
                      No
                    </button>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Product Has Members</label>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className={`toggle-btn ${isMemberEnabled ? "active" : ""}`}
                      onClick={() => setIsMemberEnabled(true)}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      className={`toggle-btn ${!isMemberEnabled ? "active" : ""}`}
                      onClick={() => setIsMemberEnabled(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center gap-3 mt-5">
                <button type="submit" className="saveButton d-flex align-items-center px-4" disabled={isSubmitting}>
                  <LuSave className="me-2" />
                  {isSubmitting ? "Saving..." : "Save"}
                </button>
                <button type="button" className="backButton d-flex align-items-center px-4" onClick={() => window.history.back()}>
                  <GiCrossedBones className="me-2" />
                  Cancel
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddOtherProduct;
